import React from "react";
import { MicrositeContactDetails } from "generated/types/types";
import { useTranslation } from "react-i18next";

interface Props {
    contactDetails: MicrositeContactDetails;
}

/**
 * A section displaying a phone number and email address where available.
 */
export const ContactDetails: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const contactDetails = props.contactDetails;
    return (
        <>
            {contactDetails?.phoneNumber ? (
                <p>
                    {t("contact_details_telephone")}<a href={`tel:${contactDetails.phoneNumber}`}>{contactDetails.phoneNumber}</a>
                </p>
            ) : null}
            {contactDetails?.email ? (
                <p>
                    {t("contact_details_email")}<a href={`mailto:${contactDetails.email}`}>{contactDetails.email}</a>
                </p>
            ) : null}
        </>
    );
};
